import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "modal-body px-6" }
const _hoisted_2 = { class: "text-sm text-text-textStrong mt-2 mb-0.5" }
const _hoisted_3 = {
  key: 1,
  class: "flex items-center mb-6 mt-1.5"
}
const _hoisted_4 = { class: "sprint-date-placeholder" }
const _hoisted_5 = { class: "font-normal text-sm text-text-default ml-2" }
const _hoisted_6 = { class: "font-normal text-sm text-text-default mx-2" }
const _hoisted_7 = { class: "sprint-date-placeholder" }
const _hoisted_8 = { class: "font-normal text-sm text-text-default ml-2" }
const _hoisted_9 = { class: "flex items-center justify-between px-6 pb-6" }

import { ref, computed, defineAsyncComponent, onMounted, watch } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import ButtonCustom from '@/components/elements/ButtonCustom';
import StInput from '@/components/elements/StInput';
import useTranslate from '@/utilities/composables/useTranslate';
import useCustomIcon from '@/utilities/composables/useCustomIcon';
import { convertTimestampToDateSecondFormatWithDay } from '@/utilities/timeDifference';
import PopupHeader from '@/components/elements/PopupHeader';
import constants from '@/utilities/constants';


export default /*@__PURE__*/_defineComponent({
  __name: 'SprintEditModal',
  setup(__props) {

const DateTimePicker = defineAsyncComponent(
  () => import(/* webpackChunkName: "sprintModal" */ '@/components/widgets/DateTimePicker')
);

const store = useStore();
const route = useRoute();

const { translate } = useTranslate();
const { iconPath, getCustomIconStyle } = useCustomIcon();

const sprintName = ref('');
const startDate = ref();
const endDate = ref();

onMounted(() => {
  sprintName.value = sprint.value?.title || '';
  startDate.value = sprint.value?.start_date || 0;
  endDate.value = sprint.value?.end_date || 0;
});

const projectId = computed(() => store.getters.getCurrentProjectId);

const headerTitle = computed(() => {
  return modalType.value === 'changeDates'
    ? translate('changeSprintDatesFor', { sprintName: sprint.value.title })
    : translate('renameSprint');
});

const submitButtonText = computed(() => {
  return translate(modalType.value);
});

const bodyDescription = computed(() => {
  return modalType.value === 'changeDates'
    ? translate('chooseNewStartAndEndDates', { sprintName: sprint.value.title })
    : translate('renameSprintDescription');
});

const sprintForEdit = computed(() => {
  return store.getters.getSprintForEditId;
});

const modalType = computed(() => {
  return sprintForEdit.value?.action;
});

const sprint = computed(() => {
  return store.getters.getSpaceSprints(projectId.value)[sprintForEdit.value?.id] || {};
});

const sprintStartDateToString = computed(() => {
  return convertTimestampToDateSecondFormatWithDay(startDate.value);
});

const sprintEndDateToString = computed(() => {
  return convertTimestampToDateSecondFormatWithDay(endDate.value);
});

const disableSubmit = computed(() => {
  return (
    ((sprintName.value === '' || sprintName.value === sprint.value.title) &&
      modalType.value === 'rename') ||
    ((!startDate.value ||
      !endDate.value ||
      (startDate.value === sprint.value.start_date && endDate.value === sprint.value.end_date) ||
      startDate.value >= endDate.value) &&
      modalType.value === 'changeDates')
  );
});

const updateSprint = (payload: any, oldSprint: any) => {
  return store
    .dispatch('updateSprint', {
      projectId: projectId.value,
      sprintId: sprintForEdit.value.orginalId,
      payload,
    })
    .then(() => {
      closeModal();
    })
    .catch((err: any) => {
      if (err.response.status === 400) {
        store.dispatch('addUiNotification', {
          message: translate('startDateIsEarlierThanPreviousEndDate'),
          status: constants.uiNotificationStatuses.error,
          duration: 4000,
        });
      }
      localUpdateSprint('title', oldSprint.title);
      localUpdateSprint('start_date', oldSprint.start_date);
      localUpdateSprint('end_date', oldSprint.end_date);
    });
};

const localUpdateSprint = (prop: string, value: any) => {
  store.dispatch('localUpdateSprint', {
    projectId: projectId.value,
    sprintId: sprint.value.id,
    prop,
    value,
  });
};

const submit = () => {
  const oldSprint = { ...sprint.value };

  if (modalType.value === 'rename') {
    localUpdateSprint('title', sprintName.value);
    updateSprint({ title: sprintName.value }, oldSprint);
  }
  if (modalType.value === 'changeDates') {
    localUpdateSprint('start_date', startDate.value);
    localUpdateSprint('end_date', endDate.value);
    updateSprint(
      { start_date: sprint.value.start_date, end_date: sprint.value.end_date },
      oldSprint
    );
  }
};

const closeModal = () => {
  store.dispatch('setSprintForEdit', {});
};

const setStartDate = (date: number, hide?: Function) => {
  hide?.();
  startDate.value = date;
};

const setEndDate = (date: string, hide?: Function) => {
  hide?.();
  endDate.value = date;
};

const bodyRef = ref(document.body);
watch(
  () => route.path,
  () => closeModal()
);

return (_ctx: any,_cache: any) => {
  const _component_v_popover = _resolveComponent("v-popover")!

  return (_openBlock(), _createElementBlock("div", {
    class: "modal",
    onMousedown: closeModal
  }, [
    _createElementVNode("div", {
      class: "sprint-modal-wrap",
      onMousedown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
    }, [
      _createVNode(_unref(PopupHeader), {
        title: headerTitle.value,
        onClose: closeModal
      }, null, 8, ["title"]),
      _cache[11] || (_cache[11] = _createTextVNode()),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(bodyDescription.value), 1),
        _cache[8] || (_cache[8] = _createTextVNode()),
        (modalType.value === 'rename')
          ? (_openBlock(), _createBlock(_unref(StInput), {
              key: 'sprint-tittle',
              value: sprintName.value,
              "text-value": sprintName.value,
              "placeholder-text": _unref(translate)('enterSprintName'),
              "label-text": "",
              "input-type": 'text',
              "input-height": 36,
              "focus-field": true,
              onInput: _cache[0] || (_cache[0] = ($event: any) => (sprintName.value = $event)),
              onEnterKey: submit
            }, null, 8, ["value", "text-value", "placeholder-text"]))
          : _createCommentVNode("", true),
        _cache[9] || (_cache[9] = _createTextVNode()),
        (modalType.value === 'changeDates')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_v_popover, {
                interactive: "",
                tag: "div",
                "content-tag": "div",
                placement: "bottom",
                role: 'poper',
                trigger: 'click',
                "append-to": bodyRef.value
              }, {
                content: _withCtx(({ state, hide }) => [
                  (state.isVisible)
                    ? (_openBlock(), _createBlock(_unref(DateTimePicker), {
                        key: 0,
                        property: 'start_date',
                        "selected-date": startDate.value,
                        "disable-delete": true,
                        onDueDate: ($event: any) => (setStartDate($event, hide)),
                        onEsc: hide
                      }, null, 8, ["selected-date", "onDueDate", "onEsc"]))
                    : _createCommentVNode("", true)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("em", {
                      class: "custom-icons bg-icon-default",
                      style: _normalizeStyle(_unref(getCustomIconStyle)(_unref(iconPath)('calendar')))
                    }, null, 4),
                    _cache[2] || (_cache[2] = _createTextVNode()),
                    _createElementVNode("span", _hoisted_5, _toDisplayString(sprintStartDateToString.value), 1)
                  ]),
                  _cache[3] || (_cache[3] = _createTextVNode())
                ]),
                _: 1
              }, 8, ["append-to"]),
              _cache[6] || (_cache[6] = _createTextVNode()),
              _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(translate)('to')), 1),
              _cache[7] || (_cache[7] = _createTextVNode()),
              _createVNode(_component_v_popover, {
                interactive: "",
                tag: "div",
                "content-tag": "div",
                placement: "bottom",
                role: 'poper',
                trigger: 'click',
                "append-to": bodyRef.value
              }, {
                content: _withCtx(({ state, hide }) => [
                  (state.isVisible)
                    ? (_openBlock(), _createBlock(_unref(DateTimePicker), {
                        key: 0,
                        property: 'due_date',
                        "selected-date": endDate.value,
                        "disable-delete": true,
                        onDueDate: ($event: any) => (setEndDate($event, hide)),
                        onEsc: hide
                      }, null, 8, ["selected-date", "onDueDate", "onEsc"]))
                    : _createCommentVNode("", true)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("em", {
                      class: "custom-icons bg-icon-default",
                      style: _normalizeStyle(_unref(getCustomIconStyle)(_unref(iconPath)('calendar')))
                    }, null, 4),
                    _cache[4] || (_cache[4] = _createTextVNode()),
                    _createElementVNode("span", _hoisted_8, _toDisplayString(sprintEndDateToString.value), 1)
                  ]),
                  _cache[5] || (_cache[5] = _createTextVNode())
                ]),
                _: 1
              }, 8, ["append-to"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _cache[12] || (_cache[12] = _createTextVNode()),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_unref(ButtonCustom), {
          class: "text-sm font-normal rounded",
          text: _unref(translate)('cancel'),
          type: 'popup-button-wrap important-custom',
          "button-dimensions": { width: 173, height: 32 },
          onClick: closeModal
        }, null, 8, ["text"]),
        _cache[10] || (_cache[10] = _createTextVNode()),
        _createVNode(_unref(ButtonCustom), {
          class: "text-sm font-normal rounded",
          text: submitButtonText.value,
          type: 'popup-button-wrap attention',
          "button-dimensions": { width: 173, height: 32 },
          disabled: disableSubmit.value,
          onClick: submit
        }, null, 8, ["text", "disabled"])
      ])
    ], 32)
  ], 32))
}
}

})